import LazyLoad from 'vanilla-lazyload'
class BannerLazyLoad {
  private intersectionObservers: IntersectionObserver[]

  constructor() {
    this.intersectionObservers = []
  }

  private createIntersectionObserver(onImageLoaded: () => void): IntersectionObserver | null {
    if ('IntersectionObserver' in window) {
      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            onImageLoaded()
          }
        })
      })

      this.intersectionObservers.push(intersectionObserver)
      return intersectionObserver
    }
    return null
  }

  private lazyLoadMedia = (
    banner: HTMLElement,
    onImageLoaded: () => void,
    onImageError: () => void
  ): void => {
    const options = {
      unobserve_entered: true,
      container: banner,
      elements_selector: 'img, video',
      callback_loaded: () => {
        onImageLoaded()
      },
      callback_error: () => {
        onImageError()
      },
    }

    const lazyLoader = new LazyLoad(options)
    lazyLoader.update()
  }

  public observeImage(
    imageEl: HTMLElement,
    onImageLoaded: () => void,
    onImageError = () => {
      return
    }
  ): void {
    const intersectionObserver = this.createIntersectionObserver(() => {
      this.lazyLoadMedia(imageEl, onImageLoaded, onImageError)
    })

    if (intersectionObserver) {
      intersectionObserver.observe(imageEl)
    } else {
      this.lazyLoadMedia(imageEl, onImageLoaded, onImageError)
    }
  }

  public unobserveImage(imageEl: HTMLElement): void {
    this.intersectionObservers.forEach((observer) => {
      observer.unobserve(imageEl)
    })
  }

  public resetObserver = (banner: HTMLElement): void => {
    LazyLoad.resetStatus(banner)
  }
}
export default new BannerLazyLoad()
